module.exports = __webpack_public_path__ + "2d97244aee8dd8088bd6ae0e1de61dc2.png";